import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e43b1ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foot-nav-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-nav-title" }, "快速导航", -1))

import {AppConfig} from "@/config";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'foot-nav',
  setup(__props) {

const onBtnClick = (route:string)=>{
  router.push(route)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", {
      class: "font-nav-text",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onBtnClick(_unref(AppConfig).route_home)))
    }, "回到首页"),
    _createElementVNode("span", {
      class: "font-nav-text",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onBtnClick(_unref(AppConfig).route_cpCredit)))
    }, "企业信用维护"),
    _createElementVNode("span", {
      class: "font-nav-text",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (onBtnClick(_unref(AppConfig).route_about)))
    }, "关于我们")
  ]))
}
}

})